import React from 'react'
import { useForm } from 'react-hook-form'
import { TextField, Button } from '@material-ui/core'
import withTranslation from '../hocs/withTranslation'

const UseResetPasswordForm = ({ usePasswordReset, t }) => {
  const { register, handleSubmit, watch, getValues, errors } = useForm()
  const password = watch('password')
  const passwordConfirmation = watch('password_confirmation')

  const hasRequiredFields = password && passwordConfirmation
  const hasMatchingPasswords = hasRequiredFields && password === passwordConfirmation

  const onSubmit = (values) => {
    return usePasswordReset(values)
  }

  return (
    <div>
      <div className='row hugest-bottom'>
        <div className='col-xs-12 form-lg'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              name='password'
              inputRef={register({ required: true })}
              label={t('auth.password')}
              type='password'
              fullWidth
              margin='normal'
              error={!!errors.password}
              helperText={errors.password ? t('validations.required') : ''}
            />

            <TextField
              name='password_confirmation'
              inputRef={register({
                required: true,
                validate: (value) => value === getValues('password') || t('auth.passMustMatch')
              })}
              label={t('auth.confirmPass')}
              type='password'
              fullWidth
              margin='normal'
              className='reg-bottom'
              error={!!errors.password_confirmation}
              helperText={errors.password_confirmation?.message || ''}
            />

            <div className='align-center'>
              <Button
                color='primary'
                disabled={!(hasRequiredFields && hasMatchingPasswords)}
                type='submit'
                className='btn-xl login-button'
                variant='contained'
              >
                {t('auth.resetPassword')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default withTranslation(UseResetPasswordForm)
